<template>
  <div>
    <el-form :model="formObject" :rules="rules" ref="adPurchaseForm" label-width="80px" size="mini">
      <el-form-item label="活动名称" prop="mainTitle" required>
        <el-input v-model="formObject.mainTitle" :disabled="type == 2"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status" required>
        <el-radio-group v-model="formObject.status" :disabled="type == 2 || statusDisable">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="2">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="限时时间" required>
        <el-col :span="11">
          <el-form-item prop="beginDate">
            <el-date-picker
              :disabled="type == 2"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="formObject.beginDate"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col class="line txt-center" :span="2">-</el-col>
        <el-col :span="11">
          <el-form-item prop="finishDate">
            <el-date-picker
              :disabled="type == 2"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="formObject.finishDate"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>

      <el-form-item label="更多链接"  prop="moreUrl" required>
            <el-col :span="12">
                <el-input v-model="formObject.moreUrl" placeholder="请填写链接地址" :disabled="type == 2"></el-input>
            </el-col>
            <el-col class="mgl-20" :span="8">
                <el-select :disabled="type == 2" v-model="formObject.moreUrlType" placeholder="请选择">
                    <el-option
                    v-for="item in urlTypes"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                    </el-option>
                </el-select>
            </el-col>
      </el-form-item>

      <el-form-item label="活动商品">链接中应包含通配符*,例:http://*.mall.justbon.com.cn/item-7828.html</el-form-item>


        <span v-for="(item, $index) in formObject.activityAddressList" :key="$index">
        <el-form-item :label="'商品' + Number($index+1)" required>
            <el-col :span="8">
              <el-form-item prop="moreUrl">
                  <el-input v-model="item.url"  placeholder="请填写链接地址" :disabled="type == 2"></el-input>
              </el-form-item>

            </el-col>
            <el-col class="mgl-10" :span="6">
                <el-select v-model="item.urlType" :disabled="type == 2" placeholder="请选择">
                    <el-option
                    v-for="type in urlTypes"
                    :key="type.code"
                    :label="type.name"
                    :value="type.code">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="3"  class="mgl-10 text-center">
                <el-upload action="/file/upload"
                    :on-success="(res, file)=>{return handleSuccess(res,file,$index)}"
                    :show-file-list='false'
                    :disabled="type == 2" :before-upload="beforeUpload">
                    <el-button size="small" type="primary" :disabled="type == 2" v-if="item.imgUrl">上传成功</el-button>
                    <el-button size="small" type="primary" :disabled="type == 2" v-else>&nbsp;&nbsp;&nbsp;&nbsp;图片&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                </el-upload>
            </el-col>
            <el-col :span="3">
                <el-button class="mgl-20" size="small" type="primary" :disabled="type == 2" @click="scan($index)">预览</el-button>
            </el-col>
            <el-col :span="3">
              <span class="font-24 pointer mgl-5"  v-if="$index>2 && $index == (formObject.activityAddressList.length-1)
                    && type != 2">
                <i class="el-icon-circle-plus-outline" @click="activityAdd"></i>
              </span>
              <span class="font-24 pointer mgl-5" v-if="$index>3 && $index == (formObject.activityAddressList.length-1)
                    && type != 2">
                <i class="el-icon-remove-outline" @click="activityDelete($index)"></i>
              </span>
            </el-col>
      </el-form-item>
        </span>

    </el-form>
    <div>
      <h3 class="txt-center">项目列表</h3>
      <div>
        <el-popover placement="top-start" width="500" v-model="popShow" trigger="click">
          <!--项目穿梭框 START-->
          <el-transfer
            filterable
            :filter-method="queryProject"
            :props="{key:'projectID',label:'name'}"
            filter-placeholder="请输入项目名称"
            v-model="selectProjects"
            v-loading="proLoading"
            :data="projects"
          >
            <span slot-scope="{ option }" :title="option.name">{{ option.name }}</span>
          </el-transfer>
          <!--项目穿梭框 END-->
          <div class="mgt-10 txt-right">
            <el-button size="mini" type="text" @click="cancel">取消</el-button>
            <el-button type="primary" size="mini" @click="select">确定</el-button>
          </div>

          <el-button icon="el-icon-edit" slot="reference" size="mini" :disabled="type == 2">编辑</el-button>
        </el-popover>
        <el-button icon="el-icon-delete" @click="deleteProject" class="mgl-10" size="mini" :disabled="type == 2">删除</el-button>
      </div>
      <el-table ref="projectList" :data="formObject.activityProjectList" stripe style="width: 100%">
        <el-table-column v-if="type != 2" type="selection" width="55"></el-table-column>
        <el-table-column prop="projectName" label="名称" width="300"></el-table-column>
        <!-- <el-table-column v-else prop="linkAdd" label="链接" width>
          <template slot-scope="scope">
            <el-input v-model="scope.row.linkAdd" placeholder="请输入链接" size="mini"></el-input>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="dialog-footer mgt-10 txt-right">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" v-if="type != 2" type="primary" @click="finishDialog">确 定</el-button>
    </div>
  </div>
</template>

<script>
  import {types} from '@/components/advertising/adMixins'
  import {Message} from '@/components'
  import { mapState } from 'vuex'

  export default {
    name: 'ActivePurchase',
    props: {
      formObject: {
        type: Object,
        required: true
      },
      // 0: 新增,1: 修改,2:查看
      type: {
        type: Number,
        default: 0
      }
    },
    watch: {
      type: function () {
        switch (this.type) {
          case 0:
            this.$refs['adPurchaseForm'].resetFields()
            break;
          default:
            break;
        }
      }
    },
    data() {
      return {
        dialogVisible: false,
        popShow: false,
        proLoading: false,
        locations: types,
        projects: [],
        selectProjects: [],
        value: '1',
        queryProject(query, item) {
          return item.name.indexOf(query) > -1;
        },
        rules: {
          type: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          mainTitle: [
            {required: true, message: '必填项', trigger: 'blur'}
          ],
          subTitle: [
            {required: true, message: '必填项', trigger: 'blur'}
          ],
          status: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          urlType: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          beginDate: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          finishDate: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          dateState: [
            {required: true, message: '必填项', trigger: 'change'}
          ],
          imgUrl: [
            {required: true, message: '必填项', trigger: 'blur'}
          ],
          moreUrl: [
            {required: true, message: '必填项', trigger: 'blur'}
          ],
        }
      }
    },
    created() {
      this.proLoading = true
      this.$store.dispatch('adAdmin/getProjectsByUser').then(result => {
        this.projects = result
      }).finally(() => this.proLoading = false)
    },
    computed: {
      ...mapState("adAdmin", ['urlTypes', 'statusDisable']),
      fileList() {
        if (!this.formObject.imgUrl) return []
        return [{id: 0, url: this.formObject.imgUrl}]
      },
    },
    methods: {
      handleSuccess(res, file, index) {
        this.proLoading = false;
        Message.success({message: '图片上传成功'});
        this.formObject.activityAddressList[index].imgUrl = res.url;
      },
      cancel() {
        this.popShow = false
      },
      select() {
        this.formObject.activityProjectList = []
        this.popShow = false
        this.projects.forEach(project => {
          if (this.selectProjects.indexOf(project.projectID) > -1) {
            this.formObject.activityProjectList.push({projectName: project.name, projectId: project.projectID, linkAdd: ''})
          }
        })
      },
      handleClose() {
        this.$emit('close')
      },
      finishDialog() {
        this.$refs['adPurchaseForm'].validate((valid) => {
          if (valid) {
            this.$emit('finish')
            return true
          } else {
            Message.warning({message: '请正确填写表单项'})
            return false
          }
        })
      },
      beforeUpload(file) {
        this.proLoading = true;
        let imgTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];
        let type = file.type.toLowerCase();
        let isImage = imgTypes.indexOf(type) > -1;
        isImage || Message.warning('上传文件只能是 JPG,JPEG,PNG,GIF 格式');
        return isImage
      },
      scan(index){
        if(this.formObject.activityAddressList[index].imgUrl){
          window.open(this.formObject.activityAddressList[index].imgUrl)
        }else{
          Message.warning({message: '请先上传图片'})
        }
      },
      activityAdd() {
        let temp = {imgUrl: "", url: "", urlType: 1,};
        this.formObject.activityAddressList.push(temp);
      },
      activityDelete(index) {
        this.formObject.activityAddressList.splice(index, 1);
      },
      repeatCheck(arr1, arr2) {
        return arr1.filter(item => {
          return !arr2.some(c=>(c.projectId==item.projectId))
        })
      },
      deleteProject(){
        if(this.$refs.projectList.store.states.selection.length ==0){
          Message.warning("请至少选择一条数据。");
          return;
        }
        let temp = JSON.parse(JSON.stringify(this.repeatCheck(this.formObject.activityProjectList, this.$refs.projectList.store.states.selection)));
        this.formObject.activityProjectList = temp;
        this.$forceUpdate();  //进行强制渲染
      },

    }
  };
</script>

<style scoped>
  .font-24{
    font-size: 24px;
  }
</style>
